export default "__VITE_ASSET__CrCu7ugU__"